import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Product } from '../interfaces/product.model';

@Injectable({ providedIn: 'root' })
export class ContentResolver implements Resolve<Product[]> {
    constructor(private fireDb: AngularFirestore) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.fireDb.doc(`content/appContent`).get().pipe(
          map(doc => {
            return doc.data()  
          })
        );
    }
}
